/**
 * SRC Global Smoke/Exhaust Background Animation
 * Canvas-based particle system for the Street Racing Channel brand.
 * Renders smoke particles drifting upward from the bottom of the viewport.
 */
(function() {
  'use strict';

  // Respect reduced motion preference
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var canvas = document.getElementById('src-global-smoke');
  if (!canvas) return;

  var ctx = canvas.getContext('2d');
  var smokeParticles = [];
  var smokeCount = (window.innerWidth < 768) ? 8 : 18;
  var animationId = null;

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function SmokeParticle(initial) {
    this.reset(initial);
  }

  SmokeParticle.prototype.reset = function(initial) {
    var side = Math.random();
    if (side < 0.3) {
      this.x = -100;
      this.y = canvas.height - Math.random() * (canvas.height * 0.4);
    } else if (side < 0.6) {
      this.x = canvas.width + 100;
      this.y = canvas.height - Math.random() * (canvas.height * 0.4);
    } else {
      this.x = Math.random() * canvas.width;
      this.y = canvas.height + 50;
    }

    if (initial) {
      this.x = Math.random() * canvas.width;
      this.y = Math.random() * canvas.height;
    }

    this.size = Math.random() * 120 + 60;
    this.speedX = (Math.random() - 0.5) * 1.5;
    this.speedY = -(Math.random() * 0.8 + 0.3);
    this.opacity = Math.random() * 0.18 + 0.06;
    this.maxOpacity = this.opacity;
    this.life = 0;
    this.maxLife = Math.random() * 400 + 300;
    this.growthRate = Math.random() * 0.3 + 0.1;

    var colorChoice = Math.random();
    if (colorChoice < 0.4) {
      this.color = '90, 180, 240';  // Car blue (light) — matches Blue-Desktop hero
    } else if (colorChoice < 0.7) {
      this.color = '25, 75, 130';   // Car blue (deep)
    } else {
      this.color = '45, 130, 210';  // Car blue (mid)
    }
  };

  SmokeParticle.prototype.update = function() {
    this.life++;
    this.x += this.speedX + Math.sin(this.life * 0.02) * 0.3;
    this.y += this.speedY;
    this.size += this.growthRate;

    var lifeRatio = this.life / this.maxLife;
    if (lifeRatio < 0.1) {
      this.opacity = this.maxOpacity * (lifeRatio / 0.1);
    } else if (lifeRatio > 0.6) {
      this.opacity = this.maxOpacity * (1 - (lifeRatio - 0.6) / 0.4);
    }

    if (this.life >= this.maxLife || this.opacity <= 0) {
      this.reset(false);
    }
  };

  SmokeParticle.prototype.draw = function() {
    ctx.beginPath();
    var gradient = ctx.createRadialGradient(
      this.x, this.y, 0,
      this.x, this.y, this.size
    );
    gradient.addColorStop(0, 'rgba(' + this.color + ', ' + this.opacity + ')');
    gradient.addColorStop(0.4, 'rgba(' + this.color + ', ' + (this.opacity * 0.6) + ')');
    gradient.addColorStop(1, 'rgba(' + this.color + ', 0)');
    ctx.fillStyle = gradient;
    ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
    ctx.fill();
  };

  function initSmoke() {
    smokeParticles = [];
    for (var i = 0; i < smokeCount; i++) {
      smokeParticles.push(new SmokeParticle(true));
    }
  }

  function animateSmoke() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (var i = 0; i < smokeParticles.length; i++) {
      smokeParticles[i].update();
      smokeParticles[i].draw();
    }
    animationId = requestAnimationFrame(animateSmoke);
  }

  // Handle visibility changes to pause/resume animation
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }
    } else {
      if (!animationId && smokeParticles.length) {
        animateSmoke();
      }
    }
  });

  function startSmoke() {
    if (animationId) return;
    resizeCanvas();
    initSmoke();
    animateSmoke();
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(startSmoke, { timeout: 1800 });
  } else if (document.readyState === 'complete') {
    setTimeout(startSmoke, 200);
  } else {
    window.addEventListener('load', function () {
      setTimeout(startSmoke, 200);
    });
  }

  // Handle resize (debounced to avoid excessive canvas reallocation)
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resizeCanvas, 150);
  });
})();
